import React, { useContext, useState } from 'react'
import { Checkbox, Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import InputText from '../../DevComponents/InputText'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import Condicional from '../../Layout/Condicional'
import Button from '@mui/material/Button'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'

import DataTable, { DataTableCabecalhoInterface } from '../../DevComponents/DataTable'
import { useNavigate } from 'react-router-dom'
import { ClienteContatoInterface, ClienteInterface } from '../../ImportBackend/Interfaces/ClienteInterfaces'
import ClsCrud from '../../Utils/ClsCrud'

import { StatusForm } from '../../Utils/ClsCrud'
import ClsValidacao from '../../Utils/ClsValidacao'
import ClsCep from '../../Utils/ClsCep'
import DataTableCrudJSON from '../../DevComponents/DataTableCrudJSON'
import ClientesContatosForm from './ClientesContatosForm'
import ExibirJSONDev from '../../DevComponents/ExibirJSONDev'
import { CabecalhoContatos, ResetDadosContato } from './ClientesContatosFormCls'
import { TipoBIInterface, TipoBIType, TipoBITypes, TipoConexaoInterface, TipoConexaoTypes, TipoERPInterface, TipoERPType, TipoERPTypes, TipoOSInterface, TipoOSType, TipoOSTypes, TipoRHInterface, TipoRHType, TipoRHTypes } from '../../ImportBackend/types/ConstantesDataTypes'
import ComboBox from '../../DevComponents/ComboBox'
import TextArea from '../../DevComponents/TextArea'
import { DateTime } from 'luxon'

interface PesquisaInterface {
  descricao: string
}

interface PropsInterface {
  onClose?: () => void
}

export default function Clientes({ onClose }: PropsInterface) {

  const [statusForm, setStatusForm] = useState<StatusForm>(StatusForm.Pesquisando)

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'razaoSocial',
      cabecalho: 'Razão Social',
      alinhamento: 'left'
    },
    {
      campo: 'nomeFantasia',
      cabecalho: 'Nome Fantasia',
      alinhamento: 'left'
    },
    {
      campo: 'cnpj',
      cabecalho: 'CNPJ',
      alinhamento: 'left'
    },
    {
      campo: 'cidade',
      cabecalho: 'Cidade',
      alinhamento: 'left'
    },
    {
      campo: 'uf',
      cabecalho: 'UF',
      alinhamento: 'left'
    }
  ]

  const ResetDados: ClienteInterface =
  {
    idCliente: 0,
    razaoSocial: '',
    nomeFantasia: '',
    cep: '',
    endereco: '',
    bairro: '',
    cidade: '',
    uf: '',
    cnpj: '',
    ie: '',
    contatos: [],
    tipoERP: TipoERPType.SEM_ACESSO,
    conexaoERP: '',
    tipoRH: TipoRHType.SEM_ACESSO,
    conexaoRH: '',
    tipoOS: TipoOSType.SEM_ACESSO,
    conexaoOS: '',
    dataInicioDRG: DateTime.now().toISODate() || '',
    habilitarDRG: false,
    dataInicioFatorRH: DateTime.now().toISODate() || '',
    habilitarFatorRH: false,
    conexaoBI: '',
    tipoBI: TipoBIType.SEM_ACESSO,
    codigoMultiEmpresa: ''
  }

  const TituloForm = {
    [StatusForm.Incluindo]: 'Inclusão de Novo Cliente',
    [StatusForm.Excluindo]: 'Exclusão de Cliente Não Utilizado',
    [StatusForm.Pesquisando]: 'Clientes são utilizados para Cadastro do Sistema',
    [StatusForm.Editando]: 'Alteração de Dados de Clientes',
    [StatusForm.Exibindo]: 'Dados do Cliente'
  }

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const [dados, setDados] = useState<ClienteInterface>(ResetDados)

  const [erros, setErros] = useState({})

  const [pesquisa, setPesquisa] = useState<PesquisaInterface>({ descricao: '' })

  const [rsPesquisa, setRsPesquisa] = useState<Array<ClienteInterface>>([])

  const navigate = useNavigate()

  const validarDados = (): boolean => {

    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.eCNPJ('cnpj', dados, erros, retorno, true)
    retorno = clsValidacao.naoVazio('razaoSocial', dados, erros, retorno)
    retorno = clsValidacao.naoVazio('nomeFantasia', dados, erros, retorno)
    retorno = clsValidacao.naoVazio('cep', dados, erros, retorno)

    retorno = clsValidacao.naoVazio('endereco', dados, erros, retorno)
    retorno = clsValidacao.naoVazio('bairro', dados, erros, retorno)
    retorno = clsValidacao.naoVazio('cidade', dados, erros, retorno)
    retorno = clsValidacao.eUF('uf', dados, erros, retorno, false)
    retorno = clsValidacao.eData('dataInicioDRG', dados, erros, retorno)
    retorno = clsValidacao.eData('dataInicioFatorRH', dados, erros, retorno)

    setErros(erros)

    return retorno

  }

  const clsCrud: ClsCrud<ClienteInterface> = new ClsCrud(
    navigate,
    ResetDados,
    setStatusForm,
    setDados,
    setErros,
    mensagemState,
    setMensagemState,
    setRsPesquisa,
    contexto,
    validarDados,
    {
      confirmarMutation: 'updateCliente',
      excluirMutation: 'delCliente',
      campoId: 'idCliente',
      camposPesquisa: '{idCliente razaoSocial nomeFantasia cnpj cidade uf}',
      pesquisaQuery: 'getClientes',
      pesquisaPorId: 'getClientePorId',
      camposPesquisaPorId: '{idCliente razaoSocial codigoMultiEmpresa nomeFantasia cep endereco bairro cidade uf cnpj ie tipoERP conexaoERP tipoRH conexaoRH tipoOS conexaoOS tipoBI conexaoBI habilitarDRG dataInicioDRG habilitarFatorRH dataInicioFatorRH contatos { tipo numeroEmail nome observacao notificarFaturamento enviarResultado notificarRecebimentoAmostra }}'
    },
    {
      confirmando: 'Atualizando Cliente',
      erroCadastro: 'Erro ao Cadastrar Cliente',
      erroExclusao: 'Erro ao Excluir Cliente',
      erroPesquisa: 'Erro ao Pesquisar Cliente',
      pesquisando: 'Pesquisando Dados de Clientes...',
      sucessoCadastro: 'Cliente Cadastrado com sucesso!',
      atualizacaoSucesso: 'Cliente Atualizado com sucesso!',
      tituloConfirmado: 'Confirmado!',
      sucessoExclusao: 'Cliente Excluído com sucesso...',
      tituloConfirmacaoExclusao: 'Confirma?',
      tituloErroCadastro: 'Erro!',
      tituloErroExclusao: 'Erro!',
      tituloErroPesquisa: 'Erro!',
      excluindo: 'Excluindo Cliente...'
    }
  )

  const onKeyPesquisa = () => {
    clsCrud.onClickPesquisa(pesquisa.descricao, mensagemState)
  }

  const alterarCep = (novoCep: any): void => {
    if (novoCep.length === 10) {

      let clsCep: ClsCep = new ClsCep()

      clsCep.buscarCep(setMensagemState, novoCep).then(rs => {
        if (rs) {

          setDados({
            ...dados,
            cep: novoCep,
            bairro: rs.bairro,
            cidade: rs.localidade,
            endereco: rs.logradouro,
            uf: rs.uf
          })

        } else {
          setDados({ ...dados, cep: novoCep })
        }
      })

    }
  }

  const onChangeContato = (contatos: Array<ClienteContatoInterface>) => {
    setDados({ ...dados, contatos: contatos })
  }

  const onChangeTipo = (rs: TipoERPInterface | TipoRHInterface | TipoOSInterface | TipoBIInterface, campoID: string, field: string, fieldConexao: string) => {
    const conteudoConexao: string = TipoConexaoTypes.find((item: TipoConexaoInterface) => item.idTipoConexao === rs.idTipoConexao)?.modeloConexao || '{}'
    setDados({ ...dados, [fieldConexao]: conteudoConexao, [field]: rs[campoID as keyof typeof rs] })
  }

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Cadastro de Clientes
                <Typography variant="body2" gutterBottom>
                  {TituloForm[statusForm]}
                </Typography>
              </Typography>

              <IconButton onClick={() => onClose ? onClose() : statusForm === StatusForm.Pesquisando ? clsCrud.btFechar() : clsCrud.btCancelar()}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Condicional condicao={statusForm === StatusForm.Pesquisando}>

              <Grid item xs={12} sm={10} sx={{ mb: 3 }}>

                <InputText
                  dados={pesquisa}
                  field='descricao'
                  label='Pesquisar'
                  setState={setPesquisa}
                  iconeEnd="search"
                  onClickIconeEnd={() => clsCrud.onClickPesquisa(pesquisa.descricao, mensagemState)}
                  mapKeyPress={[{ key: 'Enter', onKey: onKeyPesquisa }]}
                />

              </Grid>

              <Grid item xs={12} sm={2} alignSelf='center' sx={{ mt: { xs: 0, sm: 2 }, textAlign: { xs: 'right', sm: 'center' } }}>
                <Button variant='contained' onClick={() => clsCrud.btIncluir()}>Incluir</Button>
              </Grid>

            </Condicional>

            <Condicional condicao={statusForm !== StatusForm.Pesquisando}>

              <Grid item xs={12} sm={4} md={3}>

                <InputText
                  dados={dados}
                  field='cnpj'
                  label='CNPJ'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  maxLength={18}
                  mask='cnpj'
                />

              </Grid>

              <Grid item xs={12} sm={6} md={7} sx={{ pl: { sm: 1 } }}>

                <InputText
                  dados={dados}
                  field='razaoSocial'
                  label='Razão Social'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  maxLength={100}
                />

              </Grid>

              <Grid item xs={12} sm={2} sx={{ pl: { sm: 1 } }}>

                <InputText
                  dados={dados}
                  field='codigoMultiEmpresa'
                  label='Código Multi Empresa'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  maxLength={20}
                />

              </Grid>

              <Grid item xs={12} sm={8} md={9} sx={{ pr: { sm: 1 } }}>

                <InputText
                  dados={dados}
                  field='nomeFantasia'
                  label='Nome Fantasia'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  maxLength={100}
                />

              </Grid>

              <Grid item xs={12} sm={4} md={3}>

                <InputText
                  dados={dados}
                  field='cep'
                  label='Cep'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  mask='cep'
                  onChange={(novoCep) => alterarCep(novoCep)}
                />

              </Grid>

              <Grid item xs={12}>

                <InputText
                  dados={dados}
                  field='endereco'
                  label='Endereço'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  maxLength={70}
                />

              </Grid>

              <Grid item xs={12} md={5}>

                <InputText
                  dados={dados}
                  field='bairro'
                  label='Bairro'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  maxLength={30}
                />

              </Grid>

              <Grid item xs={12} sm={9} md={5} sx={{ pl: { md: 1 } }}>

                <InputText
                  dados={dados}
                  field='cidade'
                  label='Cidade'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  maxLength={35}
                />

              </Grid>

              <Grid item xs={12} sm={3} md={2} sx={{ pl: { sm: 1 } }}>

                <InputText
                  dados={dados}
                  field='uf'
                  label='UF'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  mask='uf'
                  tipo='uppercase'
                />

              </Grid>

              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
                <Typography component="h5" variant="h5" align="left">
                  Conexões de Sistemas
                  <Typography variant="body2" gutterBottom>
                    Cadastre somente as que serão utlizadas
                  </Typography>
                </Typography>
              </Grid>

              <Grid item xs={12} md={2} sx={{ mt: 0.5 }}>
                <ComboBox
                  campoID='idTipoERP'
                  campoDescricao='descricao'
                  opcoes={TipoERPTypes}
                  dados={dados}
                  field='tipoERP'
                  setState={setDados}
                  label='Sistema ERP'
                  disabled={statusForm === StatusForm.Excluindo}
                  onChange={(rs: TipoERPInterface) => onChangeTipo(rs, 'idTipoERP', 'tipoERP', 'conexaoERP')}
                />
              </Grid>

              <Grid item xs={12} md={10} sx={{ pl: { md: 1 } }}>
                <TextArea
                  dados={dados}
                  field='conexaoERP'
                  label='Conexão ERP'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo || dados.tipoERP === TipoERPType.SEM_ACESSO}
                  height='100px'
                />

              </Grid>

              <Grid item xs={12} md={2} sx={{ mt: 0.5 }}>
                <ComboBox
                  campoID='idTipoRH'
                  campoDescricao='descricao'
                  opcoes={TipoRHTypes}
                  dados={dados}
                  field='tipoRH'
                  setState={setDados}
                  label='Sistema de Recursos Humanos'
                  disabled={statusForm === StatusForm.Excluindo}
                  onChange={(rs: TipoRHInterface) => onChangeTipo(rs, 'idTipoRH', 'tipoRH', 'conexaoRH')}
                />
              </Grid>

              <Grid item xs={12} md={10} sx={{ pl: { md: 1 } }}>
                <TextArea
                  dados={dados}
                  field='conexaoRH'
                  label='Conexão RH'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo || dados.tipoRH === TipoRHType.SEM_ACESSO}
                  height='100px'
                />

              </Grid>

              <Grid item xs={12} md={2} sx={{ mt: 0.5 }}>
                <ComboBox
                  campoID='idTipoOS'
                  campoDescricao='descricao'
                  opcoes={TipoOSTypes}
                  dados={dados}
                  field='tipoOS'
                  setState={setDados}
                  label='Sistema de Ordem de Serviços'
                  disabled={statusForm === StatusForm.Excluindo}
                  onChange={(rs: TipoOSInterface) => onChangeTipo(rs, 'idTipoOS', 'tipoOS', 'conexaoOS')}
                />
              </Grid>

              <Grid item xs={12} md={10} sx={{ pl: { md: 1 } }}>
                <TextArea
                  dados={dados}
                  field='conexaoOS'
                  label='Conexão OS'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo || dados.tipoOS === TipoOSType.SEM_ACESSO}
                  height='100px'
                />

              </Grid>

              <Grid item xs={12} md={2} sx={{ mt: 0.5 }}>
                <ComboBox
                  campoID='idTipoBI'
                  campoDescricao='descricao'
                  opcoes={TipoBITypes}
                  dados={dados}
                  field='tipoBI'
                  setState={setDados}
                  label='Sistema de Ordem de Serviços'
                  disabled={statusForm === StatusForm.Excluindo}
                  onChange={(rs: TipoBIInterface) => onChangeTipo(rs, 'idTipoBI', 'tipoBI', 'conexaoBI')}
                />
              </Grid>

              <Grid item xs={12} md={10} sx={{ pl: { md: 1 } }}>
                <TextArea
                  dados={dados}
                  field='conexaoBI'
                  label='Conexão BI'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo || dados.tipoBI === TipoBIType.SEM_ACESSO}
                  height='100px'
                />

              </Grid>

              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
                <Typography component="h5" variant="h5" align="left">
                  Habilitação de Serviços
                  <Typography variant="body2" gutterBottom>
                    Configure o que estará disponível para o cliente
                  </Typography>
                </Typography>
              </Grid>

              <Grid item xs={12} sm={3} md={2}>

                <InputText
                  dados={dados}
                  field='habilitarDRG'
                  label='Habilitar DRG'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  tipo='checkbox'
                />

              </Grid>

              <Grid item xs={12} sm={9} md={10} sx={{ pl: { sm: 1 } }}>

                <InputText
                  dados={dados}
                  field='dataInicioDRG'
                  label='Data Início DRG'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo || !dados.habilitarDRG}
                  erros={erros}
                  tipo='date'
                />

              </Grid>

              <Grid item xs={12} sm={3} md={2}>

                <InputText
                  dados={dados}
                  field='habilitarFatorRH'
                  label='Habilitar Fator RH'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  tipo='checkbox'
                />

              </Grid>

              <Grid item xs={12} sm={9} md={10} sx={{ pl: { sm: 1 } }}>

                <InputText
                  dados={dados}
                  field='dataInicioFatorRH'
                  label='Data Início Fator RH'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo || !dados.habilitarFatorRH}
                  erros={erros}
                  tipo='date'
                />

              </Grid>

              <Grid item xs={12} sx={{ mt: 3 }}>
                <DataTableCrudJSON<ClienteContatoInterface>
                  dadosIniciaisRegistro={ResetDadosContato}
                  cabecalho={CabecalhoContatos}
                  dados={dados.contatos}
                  ComponenteInputCrud={ClientesContatosForm}
                  tituloCrud='Contatos do Cliente'
                  onChange={onChangeContato}
                  disabled={statusForm === StatusForm.Excluindo}
                /*
                acoes={[
                  { icone: 'delete', toolTip: 'Excluir', onAcionador: ( _rs: ClienteContatoInterface, index: number ) => btExcluirClienteContato( index ) },
                  { icone: 'create', toolTip: 'Alterar', onAcionador: ( _rs: ClienteContatoInterface, index: number ) => btAlterarClienteContato( index ) }
                ]}
                */
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: 3 }}>

                <Condicional condicao={statusForm === StatusForm.Excluindo}>
                  <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => clsCrud.btConfirmarExclusao(dados, mensagemState, pesquisa.descricao)}>Confirmar</Button>
                </Condicional>

                <Condicional condicao={statusForm !== StatusForm.Excluindo}>
                  <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => clsCrud.btConfirmar(dados, mensagemState, statusForm, pesquisa.descricao)}>Confirmar</Button>
                </Condicional>

                <Button variant='contained' startIcon={<CloseIcon />} sx={{ py: 1 }} onClick={() => clsCrud.btCancelar()}>Cancelar</Button>

              </Grid>

            </Condicional>

            <Condicional condicao={statusForm === StatusForm.Pesquisando}>
              <Grid item xs={12} sx={{ mt: 3 }}>
                <DataTable dados={rsPesquisa} cabecalho={Cabecalho} acoes={[
                  { icone: 'delete', toolTip: 'Excluir', onAcionador: clsCrud.btExcluir },
                  { icone: 'create', toolTip: 'Alterar', onAcionador: clsCrud.btEditar }]} />
              </Grid>
            </Condicional>

            <ExibirJSONDev oque={['Dados', dados, 'Erros', erros]} />

          </Grid>
        </Paper>

      </Container>
    </>
  )
}